import { render, staticRenderFns } from "./CoverBg.vue?vue&type=template&id=7b28195b&"
import script from "./CoverBg.vue?vue&type=script&lang=js&"
export * from "./CoverBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports